import axiosApi from ".";
import {
  API_FIGMA_CONTENT,
  API_FIGMA_DELETE,
  API_FIGMA_DUPLICATE,
  API_FIGMA_FRAME_UPDATE,
  API_FIGMA_GENERATE_PAGE_IMAGES,
  API_FIGMA_GET_DESIGNS,
  API_FIGMA_PROJECT,
  API_FIGMA_UPDATE,
  API_SYNC_FRAME,
  API_UPDATE_ORDER,
  API_SAVE_GROUP,
  API_CHECK_DESIGN_STATUS
} from "../constants";
import {
  APIResponse,
  DeleteFrameRequestData,
  DesignSummary,
  DuplicateFigmaFrameRequestData,
  FigmaData,
  FigmaDesignIdentifier,
  FigmaFrameIdentifier,
  FrameMetadataUpdateRequestData,
  GenerateFigmaFrameImageRequestData,
  UpdateFigmaFrameImageRequestData,
  UpdateFigmaFrameRequestData,
} from "../types";

const getFigmaFrame = async (data: FigmaFrameIdentifier) => {
  return axiosApi.post<APIResponse<FigmaData>>(API_FIGMA_CONTENT, { ...data });
};

const getFigmaFramesUnderDesign = async (data: FigmaDesignIdentifier) => {
  return axiosApi.post<APIResponse<Array<FigmaData>>>(API_FIGMA_PROJECT, {
    ...data,
  });
};

const updateFigmaFrameContent = async (data: UpdateFigmaFrameRequestData | UpdateFigmaFrameImageRequestData) => {
  return axiosApi.post<APIResponse<{}>>(API_FIGMA_UPDATE, { ...data });
};

const generateImagesInFrame = async (
  data: GenerateFigmaFrameImageRequestData
) => {
  return axiosApi.post<APIResponse<{}>>(API_FIGMA_GENERATE_PAGE_IMAGES, {
    ...data,
  });
};

const deleteFrame = async (data: DeleteFrameRequestData) => {
  return axiosApi.post<APIResponse<{}>>(API_FIGMA_DELETE, { ...data });
};

const duplicateFrame = async (data: DuplicateFigmaFrameRequestData) => {
  return axiosApi.post<APIResponse<FigmaData>>(API_FIGMA_DUPLICATE, {
    ...data,
  });
};

const updateFigmaFrameMetadata = async (
  data: FrameMetadataUpdateRequestData
) => {
  return axiosApi.post<APIResponse<{}>>(API_FIGMA_FRAME_UPDATE, {
    ...data,
  });
};

const getFigmaFramesForUser = async () => {
  return axiosApi.get<APIResponse<DesignSummary[]>>(API_FIGMA_GET_DESIGNS);
};

const updateFrameSyncStatus = async (data: { frame_id: string }) => {
  return axiosApi.patch<APIResponse<{}>>(
    API_SYNC_FRAME, {
    ...data,
  });
};

const updateDesignsOrder = async (data: { orderUpdates: Array<{design_id: string, display_order: number}> }) => {
  return axiosApi.patch<APIResponse<{}>>(
    API_UPDATE_ORDER, {
   ...data,
  });
};

const saveGroup = async (data: { groupData: {design_id: string; group_name: string | null; frame_ids: string[];} }) => {
  return axiosApi.patch<APIResponse<{}>>(
    API_SAVE_GROUP, {
    ...data,
  });
};

const checkDesignStatus = async (data: { design_id: string, frame_id: string }) => {
  return axiosApi.post<APIResponse<{ is_open: boolean }>>(API_CHECK_DESIGN_STATUS, { ...data });
};

const figmaApi = {
  getFigmaFrame,
  getFigmaFramesUnderDesign,
  updateFigmaFrameContent,
  generateImagesInFrame,
  deleteFrame,
  duplicateFrame,
  updateFigmaFrameMetadata,
  getFigmaFrames: getFigmaFramesForUser,
  updateFrameSync: updateFrameSyncStatus, 
  updateDesignsOrder,
  saveGroup,
  checkDesignStatus
};

export default figmaApi;
